import { configGTM } from "@pub/config";
import { addScriptSrc } from "@sphtech/dmg-design-system";
import { useEffect } from "react";

export default AnalyticsGTM;

function AnalyticsGTM() {
  useEffect(() => {
    const gtm_config = { gtm_container: configGTM.container };
    addScriptSrc(`var sphm_gtm_data = ${JSON.stringify(gtm_config)}`);
  }, []);
  return null;
}
